export default __webpack_public_path__ + "static/media/plus-icon.c54eef84.svg";